import React from 'react';
import './Result.css';

class Result extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    

    render() {
        const correctResult = this.props.correctArr;
        const unansweredResult = this.props.unansweredArr;
        const correctCountries = correctResult.map((country, index) =>
            <div class="w-60 rounded-lg dark:bg-sky-900" >
                <img class=" h-40 rounded-t-lg" src={country[0][1]['flag_image']} alt=""  styles={{ maxWidth: 300, maxHeight: 150 }}/>
                <div class="p-5">
                <ul>
                    <li key={country} class="mb-2 text-xl font-bold tracking-tight text-gray-900 dark:text-white">
                     {country[0][0]} ✔️
                    </li>
                </ul>
                </div>
            </div>

        );
        const unansweredCountries = unansweredResult.map((country) =>
            <div class="w-60 bg-white rounded-lg border border-gray-200 shadow-md dark:bg-sky-900 dark:border-gray-700" >
                <img class="h-40 rounded-t-lg" src={country[1]['flag_image']} alt="" styles={{ height:"50px" }}/>
                <div class="p-5">
                <ul>
                    <li key={country} class="mb-2 text-xl font-bold tracking-tight text-gray-900 dark:text-white">
                     {country[0]} ❌
                    </li>
                </ul>
                </div>
            </div>

        );
        return(
            <div className="results">
                <div class="grid grid-cols-6 gap-4 place-content-center">
                    {correctCountries}
                    {unansweredCountries}
                </div>
            </div>
        );
    }
  }
export default Result;